<script lang="ts">
	//Stores
	import { user_data } from 'src/stores/account/user';
	//Services
	import { postReq } from '../../../services/http';
	import { handleLogout } from '../../../helpers/account_helpers';
	import { format } from '../../../services/i18n';
	//Helpers
	import { passwordCompare } from '../../../helpers/validators';
	//Types
	import type { ChangeEmailRequest } from '../../../types/requests/settings/user/change_email';
	//Design system components
	import { Button, Input, toast, Row, Col } from '@Shelly/shelly-design-system';
	import { replace } from 'svelte-spa-router';
	import { capFirstChar } from 'src/helpers/utilities';

	let newEmailValue = '',
		repeatEmailValue = '',
		passwordValue = '';

	$: mailsError = passwordCompare(newEmailValue, repeatEmailValue)
		? $format('error_emails_match', {
				default: 'The email addresses entered do not match.',
			})
		: undefined;

	// longer error handle message for non matching e-mails: "'The email addresses entered do not match. Please ensure that both email fields contain the same email address to proceed.'"
	// it might come in handy

	export const handleChangeEmail = async (newMail, oldMail, mailPass, user) => {
		if (newMail !== oldMail) {
			toast.open({
				type: 'info',
				title: $format('error_emails_match', {
					default: 'The email addresses entered do not match.',
				}),
			});
			return;
		} else {
			const res: ChangeEmailRequest = await postReq('/user/change_email', {
				new_email: newMail,
				old_email: $user_data.email,
				password: mailPass,
			});

			if (res.isok) {
				await handleLogout();
				replace('/login');
			} else if (res?.errors) {
				if (res.errors?.wrong_email) {
					return toast.open({
						type: 'danger',
						title: $format('error_email_used', {
							default: 'The new E-mail you provided is already registered to a account.',
						}),
					});
				} else if (res.errors?.wrong_password) {
					return toast.open({
						type: 'danger',
						title: $format('alert_error_wrong_pass', {
							default: 'Wrong password provided.',
						}),
					});
				} else {
					toast.open({ type: 'danger', title: $format('setting_err_toast') });
				}
			}
		}
	};
</script>

<Row>
	<Col xs="12" md="3">
		<Input
			icon={'fas fa-envelope'}
			label={capFirstChar($format('placeholder_new_email'))}
			bind:value={newEmailValue}
			type={'text'}
			id="input-wj138ps"
			aria-labelledby="input-wj138ps"
		/>
	</Col>
	<Col xs="12" md="3">
		<Input
			error={mailsError}
			icon={'fas fa-envelope'}
			label={capFirstChar($format('placeholder_repeat_new_email'))}
			bind:value={repeatEmailValue}
			type={'text'}
			id="input-fhg23cb"
			aria-labelledby="input-fhg23cb"
		/>
	</Col>
	<Col xs="12" md="3">
		<Input
			icon={'fas fa-key'}
			label={capFirstChar($format('placeholder_password'))}
			bind:value={passwordValue}
			type={'password'}
			id="input-sfyu0jb"
			aria-labelledby="input-sfyu0jb"
		/>
	</Col>
	<Col xs="12" md="3">
		<Button
			size="m"
			class="width-md-auto width-sm-full"
			disabled={passwordCompare(repeatEmailValue, newEmailValue)}
			on:click={() =>
				handleChangeEmail(newEmailValue, repeatEmailValue, passwordValue, $user_data.email)}
			>{$format('button_save')}</Button
		>
	</Col>
</Row>
